<!-- Sub-paso 5.3.1: Componente SupervisorZonaDashboard.vue (45 min) -->
<!-- DÍA 5: Dashboards Especializados por Rol - PASO 5.3 Supervisor de Campo Dashboard -->
<!-- NOTA: El menú lateral es manejado por BaseRoleDashboard.vue, no aquí -->

<template>
  <!-- Dashboard Principal del Supervisor de Zona -->
  <div class="supervisor-dashboard-layout">
    <!-- Contenido principal -->
    <!-- P13-V7B (refutation): the shell is named with the CANONICAL role. The legacy alias it used to
         pass fed the shell's permission and endpoint tables, which are gone. -->
    <base-role-dashboard
      role="field_supervisor"
      :group-id="groupId"
    >
      <!-- Indicador de conectividad -->
      <template #header-actions>
        <connection-status />
      </template>

      <template #role-content>
        <!--
          P13-V7B — THIS LANDING HAS ONE SECTION, AND IT IS THIS ONE.

          The template used to branch on `activeSection` into "Empleadas del Grupo", "Gestión de
          Agencias" and "Rutas Activas". `activeSection` was only ever assigned 'dashboard', so no
          person could reach those branches — and what they held was a table fed by
          `GET /supervisor/groups/:id/employees` and two "En desarrollo" placeholders. With them went
          the route-progress card (its `activeRoute` was never set on mount), the create-route dialog
          and the inventory and expenses dialogs, none of which had an opener anywhere in the
          repository. The backend retired the `/api/supervisor` family (410) and refuses the
          inventory and expenses routes to this role, so nothing was lost that could have worked.
        -->
        <div>
          <!-- Primera Fila: Gestión de Agencias y Rutas -->
          <v-row class="fill-height mb-4">
            <v-col cols="12" lg="8">
              <v-card title="Agencias supervisadas" :subtitle="supervisedGroupsSubtitle" class="h-100">
                <v-card-text>
                  <!-- X2-R1: read-only catalogue. `can-edit` is false AND no writer is wired: the
                       edit / change-status / create-route affordances target deferred capability
                       (`/api/supervisor/*`), so no click path may reach them from this landing. -->
                  <v-alert
                    v-if="agencyLoadError"
                    type="error"
                    variant="tonal"
                    density="compact"
                    class="mb-3"
                    data-testid="agency-load-error"
                  >{{ agencyLoadError }}</v-alert>
                  <agencies-management-panel
                    :agencies="groupAgencies"
                    :can-edit="false"
                    :loading="loadingData"
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" lg="4" class="d-flex flex-column">
              <!-- The daily route belongs to V4 and is not sold to this role. The card states that
                   and offers nothing: no reader is issued for it and no control can start one. -->
              <v-card title="Ruta diaria no disponible" class="h-100" data-testid="daily-route-unavailable">
                <v-card-text>
                  <v-alert
                    type="info"
                    variant="tonal"
                    density="comfortable"
                    class="mb-4"
                  >
                    La ruta diaria del supervisor está pendiente de implementación backend con alcance real.
                  </v-alert>
                  <v-btn
                    block
                    color="grey"
                    variant="outlined"
                    disabled
                  >
                    <v-icon start>mdi-progress-wrench</v-icon>
                    Creación de rutas no disponible
                  </v-btn>
                  <v-divider class="my-4" />
                  <p class="text-medium-emphasis">
                    No se muestran rutas simuladas ni se permite crear rutas sin contrato backend scoped.
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Segunda Fila: Mapa Interactivo e Incidencias/Reportes -->
          <v-row class="mt-4">
            <v-col cols="12" lg="8" class="d-flex">
              <v-card class="h-100 d-flex flex-column flex-grow-1">
                <!-- P13-V7B: the "{n} elementos" chip is RETIRED. It added the agency catalogue, a
                     second unfiltered read of the zone's incidents and the (never loaded) route,
                     while the map plots none of the agencies and only the active incidents that
                     carry coordinates. A count that does not describe the thing it sits on is not a
                     measurement; the map states its own layer counts. -->
                <v-card-title class="d-flex align-center">
                  <v-icon class="me-2">mdi-map-marker-radius</v-icon>
                  Mapa de Campo - Supervisión de Zona
                </v-card-title>
                <v-card-text class="flex-grow-1 pa-0" style="min-height: 400px;">
                  <!-- X2-R1: the POS layer reads the contained `/field-supervisor/assigned-agencies`.
                       The capability is withdrawn here, and the map now honours it during ACQUISITION,
                       so the delivered landing never issues that request. POS markers are not restored:
                       the canonical reader carries no coordinates.

                       The attribute is spelled `:showMyPOS` ON PURPOSE. Vue camelises `show-my-pos`
                       to `showMyPos`, which does NOT match the declared prop `showMyPOS`, so the
                       kebab-case form never bound: the map silently kept its default (`true`) and the
                       landing's previous `:show-my-pos="true"` was just as inert. Spelling the prop
                       exactly as declared is what makes this capability expressible at all.

                       P13-V7B (refutation): the routes layer is withdrawn the same way. Its reader
                       (`SupervisorService.getSupervisorRoutes`) issues no request and answers `[]` — there
                       is no route producer for this role (V4) — so the landing drew "Rutas (0)" and a
                       toggle over a layer that can never hold anything. -->
                  <supervisor-interactive-map
                    :supervisor-id="groupId"
                    :show-my-routes="false"
                    :show-my-incidents="true"
                    :showMyPOS="false"
                    :enable-limited-controls="true"
                    style="height: 100%;"
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <!-- P13-V1D (C10): el panel legacy de validación/escalación (IncidentsSupervisorPanel)
                 fue RETIRADO — golpeaba endpoints phantom (/supervisor/incidents/:id/validate|escalate)
                 con vocabulario retirado. La superficie canónica es la bandeja de zona de abajo
                 (IncidentInbox: acciones proyectadas por el servidor). -->
          </v-row>

          <!-- Bandeja de Incidencias de la Zona (Lote 4.2) -->
          <v-row class="mt-4">
            <v-col cols="12">
              <IncidentInbox inbox-type="zone" />
            </v-col>
          </v-row>

          <!-- P13-V1D (C11): escalaciones dirigidas a mí — QUERY_DRIVEN (decisión congelada #10):
               carga al montar, tras acción local y con refresh manual; SIN señales realtime
               (la entrega inmediata visible es la notificación durable K4B en la UI canónica). -->
          <v-row class="mt-4">
            <v-col cols="12">
              <IncidentInbox inbox-type="escalated" />
            </v-col>
          </v-row>
        </div>
      </template>
  </base-role-dashboard>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import BaseRoleDashboard from '@/components/specialized/BaseRoleDashboard.vue'
// @ts-ignore
import { SupervisorZonaService } from '@/services/roles/SupervisorZonaService.js'
// X2-R1: the canonical scoped agency corridor — the SAME authority the signed intake consumes.
import SupervisorService from '@/services/supervisorService'
// @ts-ignore
import websocketService from '@/services/websocket.service'
import ConnectionStatus from '@/components/common/ConnectionStatus.vue'
import SupervisorInteractiveMap from '@/views/maps/SupervisorInteractiveMap.vue'
import AgenciesManagementPanel from '@/components/supervisor/AgenciesManagementPanel.vue'
import IncidentInbox from '@/components/incidents/IncidentInbox.vue'
import { useAuthStore } from '@/stores/auth'

// Interfaces TypeScript
/**
 * X2-R1: the shape the canonical scoped reader authorises. `status`, `lastVisit`, `issues` and
 * `manager` are gone because `GET /api/groups/with-agencies` measures none of them; keeping them
 * here is what allowed the delivered landing to default them into apparent business facts.
 */
interface Agency {
  id: number
  name: string
  address: string | null
  groupId: number
  groupName: string
}

interface SupervisedGroup {
  groupId: number
  groupName: string
}

// Determinar groupId del supervisor desde el store si está disponible
const authStore = useAuthStore?.() as any
const initialGroupId = authStore?.user?.groupId || authStore?.user?.assignedGroupId || authStore?.user?.group?.id
const groupId = ref(initialGroupId || null)

// NOTA: El menú lateral es manejado por BaseRoleDashboard.vue

const supervisorService = new SupervisorZonaService()
// WebSocket service
const webSocket = websocketService

// Estado reactivo con tipado
const groupAgencies = ref<Agency[]>([])
/** X2-R1: every group the SERVER placed in this supervisor's partition (never an auth-store alias). */
const supervisedGroups = ref<SupervisedGroup[]>([])
/** X2-R1: a NAMED failure of the canonical reader — never a silently empty catalogue. */
const agencyLoadError = ref<string | null>(null)
const pendingExpensesCount = ref<number>(0)
const loadingData = ref<boolean>(false)
const fondoDisponible = ref<number>(0)

// Computed properties
// X2-R1: the former `groupStatus` computed (total / operational / percentage) was removed with the
// status vocabulary it counted — no reader on this landing measures an agency's operational state,
// and it was rendered nowhere.

/**
 * X2-R1: the card names the groups the SERVER returned — all of them. The landing no longer speaks
 * of "mi grupo" in the singular, because a supervisor may canonically supervise several and the
 * auth-store alias is not the authority for which.
 */
const supervisedGroupsSubtitle = computed(() => {
  if (!supervisedGroups.value.length) return 'Alcance canónico del servidor'
  const names = supervisedGroups.value.map((g) => g.groupName).join(' · ')
  return supervisedGroups.value.length === 1 ? `Grupo: ${names}` : `Grupos supervisados (${supervisedGroups.value.length}): ${names}`
})

// Métodos de gestión de agencias
//
// X2-R1: `editAgency` and `changeAgencyStatus` were REMOVED with the affordances that reached them.
// They dispatched `PUT /api/supervisor/agencies/:id` and `PATCH /api/supervisor/agencies/:id/status`
// — deferred capability this pilot does not sign — and their failure path called an undefined
// `handleServiceError`, so a rejected write threw a ReferenceError instead of reporting anything.
// The delivered landing is a read-only catalogue: the panel renders no writer, and no handler here
// can be reached from it. Restoring either affordance requires the writers to exist first.

// Métodos de rutas
// X2-R1: `createVisitRoute` was REMOVED with the panel's "Crear Ruta" affordance, its only caller.
// It dispatched `POST /api/supervisor/routes` — deferred capability, and the sibling card on this
// same screen already states route creation is unavailable.

/**
 * P13-V7B — WHAT ELSE LEFT THE SCRIPT, AND WHY.
 *
 * Every handler below was reachable only from a template branch that could never render, so each
 * was removed together with its branch:
 *   · `updateVisitStatus`, `loadActiveRoute`      → the route-progress card; `activeRoute` was only
 *     ever assigned inside `loadActiveRoute`, whose only caller was `updateVisitStatus`, which lived
 *     inside the card that `activeRoute` gated. A closed loop with no entry.
 *   · `viewEmployee`, `manageSchedule`, `loadGroupEmployees` → the employees section. `viewEmployee`
 *     was an `alert('... Función en desarrollo')`.
 *   · `onRouteCreated`                            → the create-route dialog (no opener).
 *   · `onInventoryRequestCreated`, `handleVariableExpenseCreated` → the inventory and expenses
 *     dialogs (no opener).
 * The second read of `GET /field-supervisor/incidents` went with the count chip it fed: the map and
 * the zone inbox read the zone's incidents through their own adapters, and nothing else here used it.
 */

// P13-V1D (C10): los handlers del panel legacy (validate/escalate/report — endpoints phantom)
// fueron retirados junto con el panel.

/**
 * Cargar el catálogo canónico de agencias supervisadas.
 *
 * MGI-PILOT-W2-X2-FS-LANDING-CANONICAL-DATA-R1 — ONE AGENCY AUTHORITY.
 *
 * The catalogue used to come from `SupervisorZonaService.getGroupAgencies`, i.e.
 * `GET /api/field-supervisor/assigned-agencies` — a route the role-home perimeter contains to
 * vendor-only. The delivered supervisor received a 403, the service swallowed it and returned `[]`,
 * and the landing published an EMPTY panel as though the estate were empty.
 *
 * The single authority is now the server-scoped reader `GET /api/groups/with-agencies` through the
 * strict adapter `SupervisorService.getSupervisedGroupsWithAgencies()` (the same corridor the signed
 * intake uses). Every agency it returns is one the SERVER placed in this supervisor's partition and
 * bound to its own owning group; a same-administration agency the supervisor does not supervise, and
 * any cross-administration agency, never enter the response. There is NO fallback: an impossible
 * shape is a named failure, never a silently empty list, and the contained reader is not consulted.
 *
 * SCOPE DISCIPLINE. `groupId` (seeded from auth-store aliases) neither filters nor widens this
 * result: ALL canonically supervised groups are rendered. It is not reassigned from the catalogue
 * either — the server result is the authority, and the auth-store alias remains purely presentational
 * for the surfaces that still read it.
 *
 * HONESTY. Only fields the reader carries are mapped. Operational status, last visit, incidence
 * counts and agency managers are NOT in this reader, so they are not invented here — the panel
 * renders the catalogue without them rather than defaulting them into apparent facts.
 */
const loadGroupData = async () => {
  try {
    loadingData.value = true

    const { groups, agencies } = await SupervisorService.getSupervisedGroupsWithAgencies()
    supervisedGroups.value = groups
    groupAgencies.value = agencies.map((agency) => ({
      id: agency.agencyId,
      name: agency.agencyName,
      address: agency.address,
      groupId: agency.groupId,
      groupName: agency.groupName
    }))

    agencyLoadError.value = null
    console.log('✅ Catálogo canónico cargado:', { groups: groups.length, agencies: groupAgencies.value.length })

  } catch (error: any) {
    console.error('❌ Error cargando el catálogo canónico de agencias:', error)

    // No fallback reader, and no invented catalogue: the failure is NAMED and the panel stays empty.
    groupAgencies.value = []
    supervisedGroups.value = []
    agencyLoadError.value = error?.message
      ? `No se pudo cargar el catálogo de agencias: ${error.message}`
      : 'No se pudo cargar el catálogo de agencias.'

  } finally {
    loadingData.value = false
  }
}

/**
 * P13-V7B — THE TWO DEFERRED LOADERS ARE RETAINED UNCALLED, DELIBERATELY.
 *
 * `loadPendingExpensesCount` and `loadFondoDisponible` have no caller and no template binding; the
 * expenses dialog that read `fondoDisponible` is gone. They stay because the accepted X2 contract
 * pins exactly this shape — lane X2-G7 asserts `pendingExpensesCount` and the two service methods,
 * and its mutation control restores these two calls to the mount to prove the lane can fail. A
 * merged harness is not edited to make a cleanup look complete. Removing them is a decision for the
 * owner of that contract.
 */
// 🆕 Cargar contador de gastos fijos pendientes
const loadPendingExpensesCount = async () => {
  try {
    const response = await supervisorService.getPendingExpenses()
    if (response?.data?.pending) {
      pendingExpensesCount.value = response.data.pending.length || 0
    }
  } catch (error) {
    console.error('Error cargando gastos pendientes:', error)
    pendingExpensesCount.value = 0
  }
}

// 🆕 Cargar fondo disponible del grupo
const loadFondoDisponible = async () => {
  try {
    const response = await supervisorService.getGroupInfo()
    const data = response?.data || response
    fondoDisponible.value = parseFloat(data?.fondo_disponible || data?.group?.fondo_disponible || 0)
  } catch (error) {
    console.error('Error cargando fondo disponible:', error)
    fondoDisponible.value = 0
  }
}

onMounted(() => {
  console.log('🚀 Iniciando SupervisorZonaDashboard')
  initializeWebSocket()
  loadGroupData()
  // X2-R1: `loadPendingExpensesCount()` and `loadFondoDisponible()` are NOT prefetched here.
  // They read `/api/field-supervisor/expenses/pending` and `/api/field-supervisor/group-info`,
  // both contained to vendor-only, and both answered a fabricated zero on 403 — a pending-expense
  // count and a fund balance nobody measured. Neither value is rendered on the delivered landing.
})

// ===============================
// 🔌 CONEXIÓN REALTIME
// ===============================

/**
 * P13-V7B — the landing CONNECTS and subscribes to nothing.
 *
 * It used to register three listeners — `incident_updated`, `route_progress_updated` and
 * `team_assignment_updated`. The backend's realtime catalogue records all three as RETIRED with no
 * producer, and the client socket bridge forwards none of them, so the handlers could never run.
 * One of them raised a blocking `alert()` for a "critical incident" it would have materialised
 * straight from the payload. The connection itself is kept: the header's connectivity indicator
 * reports the state of this socket, and the canonical incident surfaces below are query-driven.
 */
const initializeWebSocket = async () => {
  try {
    await webSocket.connect()
  } catch (error) {
    console.error('❌ Error inicializando WebSocket:', error)
  }
}
</script>

<style scoped>
/* Asegurar altura igual en componentes laterales */
.fill-height {
  height: 100%;
}

.h-100 {
  height: 100%;
}

.flex-grow-1 {
  flex-grow: 1;
}
</style>
